module.exports = __webpack_public_path__ + "assets/img/sub.png?17d3ab179ef792302dc973461e49d690";